import { render, staticRenderFns } from "./SocialResponsibility.vue?vue&type=template&id=73af8ef3&scoped=true&"
import script from "./SocialResponsibility.vue?vue&type=script&lang=js&"
export * from "./SocialResponsibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73af8ef3",
  null
  
)

export default component.exports